<p [style.column-count]="context.columns && context.columns"
    [style.column-gap]="context.columnGap || '2rem'"
    [innerHtml]="context.content | filterHTML">
</p>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/paragraph/paragraph.component.html